/**
 * Store defines all modules automatically via autoloader
 * Place common vuex store in the @/modules/core dir
 */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    words: [
      'Hollywood',
      'Screen',
      'Play',
      'Marble',
      'Dinosaur',
      'Cat',
      'Pitch',
      'Bond',
      'Greece',
      'Deck',
      'Spike',
      'Center',
      'Vacuum',
      'Unicorn',
      'Undertaker',
      'Sock',
      'Loch Ness',
      'Horse',
      'Berlin',
      'Platypus',
      'Port',
      'Chest',
      'Box',
      'Compound',
      'Ship',
      'Watch',
      'Space',
      'Flute',
      'Tower',
      'Death',
      'Bill',
      'Shot',
      'King',
      'Pan',
      'Square',
      'Buffalo',
      'Scientist',
      'Chick',
      'Atlantis',
      'Spy',
      'Mail',
      'Nut',
      'Log',
      'Pirate',
      'Face',
      'Stick',
      'Disease',
      'Yard',
      'Mount',
      'Slug',
      'Dice',
      'Lead',
      'Hook',
      'Carrot',
      'Poison',
      'Stock',
      'Foot',
      'Torch',
      'Arm',
      'Figure',
      'Mine',
      'Suit',
      'Crane',
      'Beijing',
      'Mass',
      'Microscope',
      'Engine',
      'China',
      'Straw',
      'Pants',
      'Europez',
      'Boot',
      'Princess',
      'Link',
      'Luck',
      'Olive',
      'Palm',
      'Teacher',
      'Thumb',
      'Octopus',
      'Hood',
      'Tie',
      'Doctor',
      'Wake',
      'Cricket',
      'Millionarie',
      'New York',
      'State',
      'Bermuda',
      'Park',
      'Turkey',
      'Chocolate',
      'Trip',
      'Racket',
      'Bat',
      'Jet',
      'Shakespeare',
      'Bolt',
      'Switch',
      'Wall',
      'Soul',
      'Ghost',
      'Time',
      'Dance',
      'Amazon',
      'Grace',
      'Moscow',
      'Pumpkin',
      'Antarctica',
      'Whip',
      'Heart',
      'Table',
      'Ball',
      'Fighter',
      'Cold',
      'Day',
      'Spring',
      'Match',
      'Diamond',
      'Centaur',
      'March',
      'Roulette',
      'Dog',
      'Cross',
      'Wave',
      'Duck',
      'Wind',
      'Spot',
      'Skyscraper',
      'Paper',
      'Apple',
      'Oil',
      'Cook',
      'Fly',
      'Cast',
      'Bear',
      'Pin',
      'Thief',
      'Trunk',
      'America',
      'Novel',
      'Cell',
      'Bow',
      'Model',
      'Knife',
      'Knight',
      'Court',
      'Iron',
      'Whale',
      'Shadow',
      'Contract',
      'Mercury',
      'Conductor',
      'Seal',
      'Car',
      'Ring',
      'Kid',
      'Piano',
      'Laser',
      'Sound',
      'Pole',
      'Superhero',
      'Revolution',
      'Pit',
      'Gas',
      'Glass',
      'Washington',
      'Bark',
      'Snow',
      'Ivory',
      'Pipe',
      'Cover',
      'Degree',
      'Tokyo',
      'Church',
      'Pie',
      'Tube',
      'Block',
      'Comic',
      'Fish',
      'Bridge',
      'Moon',
      'Part',
      'Aztec',
      'Smuggler',
      'Train',
      'Embassy',
      'Pupil',
      'Scuba Diver',
      'Ice',
      'Tap',
      'Code',
      'Shoe',
      'Server',
      'Club',
      'Row',
      'Pyramid',
      'Bug',
      'Penguin',
      'Pound',
      'Himalayas',
      'Czech',
      'Rome',
      'Eye',
      'Board',
      'Bed',
      'Point',
      'France',
      'Mammoth',
      'Cotton',
      'Robin',
      'Net',
      'Bugle',
      'Maple',
      'England',
      'Field',
      'Robot',
      'Plot',
      'Africa',
      'Tag',
      'Mouth',
      'Kiwi',
      'Mole',
      'School',
      'Sink',
      'Pistol',
      'Opera',
      'Mint',
      'Root',
      'Sub',
      'Crown',
      'Back',
      'Plane',
      'Mexico',
      'Cloak',
      'Circle',
      'Tablet',
      'Australia',
      'Green',
      'Egypt',
      'Line',
      'Lawyer',
      'Witch',
      'Parachute',
      'Crash',
      'Gold',
      'Note',
      'Lion',
      'Plastic',
      'Web',
      'Ambulance',
      'Hospital',
      'Spell',
      'Lock',
      'Water',
      'London',
      'Casino',
      'Cycle',
      'Bar',
      'Cliff',
      'Round',
      'Bomb',
      'Giant',
      'Hand',
      'Ninja',
      'Rose',
      'Slip',
      'Limousine',
      'Pass',
      'Theater',
      'Plate',
      'Satellite',
      'Ketchup',
      'Hotel',
      'Tail',
      'Tick',
      'Ground',
      'Police',
      'Dwarf',
      'Fan',
      'Dress',
      'Saturn',
      'Grass',
      'Brush',
      'Chair',
      'Rock',
      'Pilot',
      'Telescope',
      'File',
      'Lab',
      'India',
      'Ruler',
      'Nail',
      'Swing',
      'Olympus',
      'Change',
      'Date',
      'Stream',
      'Missile',
      'Scale',
      'Band',
      'Angel',
      'Press',
      'Berry',
      'Card',
      'Check',
      'Draft',
      'Head',
      'Lap',
      'Orange',
      'Ice Cream',
      'Film',
      'Washer',
      'Pool',
      'Shark',
      'Van',
      'String',
      'Calf',
      'Hawk',
      'Eagle',
      'Needle',
      'Forest',
      'Dragon',
      'Key',
      'Belt',
      'Cap',
      'Drill',
      'Glove',
      'Paste',
      'Fall',
      'Fire',
      'Spider',
      'Spine',
      'Soldier',
      'Horn',
      'Queen',
      'Ham',
      'Litter',
      'Life',
      'Temple',
      'Rabbit',
      'Button',
      'Game',
      'Star',
      'Jupiter',
      'Vet',
      'Night',
      'Air',
      'Battery',
      'Genious',
      'Shop',
      'Bottle',
      'Stadium',
      'Alien',
      'Light',
      'Triangle',
      'Lemon',
      'Nurse',
      'Drop',
      'Track',
      'Bank',
      'Germany',
      'Worm',
      'Ray',
      'Capital',
      'Strike',
      'War',
      'Concert',
      'Honey',
      'Canada',
      'Buck',
      'Snowman',
      'Beat',
      'Jam',
      'Copper',
      'Beach',
      'Bell',
      'Leprechaun',
      'Pheonix',
      'Force',
      'Boom',
      'Fork',
      'Alps',
      'Post',
      'Fence',
      'Kangaroo',
      'Mouse',
      'Mug',
      'Horseshoe',
      'Scorpion',
      'Agent',
      'Helicopter',
      'Hole',
      'Organ',
      'Jack',
      'Charge'
    ]
  }
})
